import { render, staticRenderFns } from "./AL.Index.vue?vue&type=template&id=63868ce6"
import script from "./AL.Index.vue.ts?vue&type=script&lang=ts&external"
export * from "./AL.Index.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports